import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  constructor(private titleService: Title) { }

  setTitle(title: string) {
    this.titleService.setTitle(title);
  }
}
